import { IconTokens, InputStateToken } from '@voltmoney/schema';
import { getApplicationId, getParameters, isFromAndroidWebview, isFromTDLPlatform, MfCentralFlow, nextStepId } from '../../../configs/utils';
import SharedPropsService from '../../../SharedPropsService';
import { ROUTE } from '../../../routes';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import { Platform } from "react-native";
let emailId = '';
let counter = 0;
export const saveEmailId = async (action, _datastore, { network, setDatastore, navigate, analytics, showPopup, instrumentTrack, addUseProperty }) => {
    const email = action?.payload?.value;
    await setDatastore(action.routeId, 'enterEmailScreen', {
        state: InputStateToken.DEFAULT,
        counter: counter++
    });
    const user = await SharedPropsService.getUser();
    const response = await network.post(`${api.triggerEmailOtp}`, {
        borrowerAccountId: user.linkedBorrowerAccounts[0].accountId,
        emailId: email
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        const numberOfDigits = response?.data?.noOfDigits;
        if (numberOfDigits) {
            await SharedPropsService.setNumberOfOtpDigits(numberOfDigits);
        }
        const numberOfOtp = numberOfDigits ? numberOfDigits : await SharedPropsService.getNumberOfOtpDigits();
        await setDatastore(action.routeId, 'enterEmailScreen', {
            numberOfOtp: numberOfOtp,
            email: email,
            showErrorModal: false,
            counter: counter++,
        });
    }
    else {
        if (response?.response?.status === 400) {
            await setDatastore(action.routeId, 'enterEmailScreen', {
                showErrorModal: true,
                counter: counter++,
                errorMessage: response?.response?.data?.message,
            });
        }
        else {
            await showPopup({
                title: 'Something went wrong',
                type: 'DEFAULT',
                iconName: IconTokens.Alert,
                ctaLabel: 'OK',
            });
        }
    }
    // await navigate(ROUTE.EMAIL_VERIFY_OTP,{emailId : email})
};
export const DisbursalVerifyAction = async (action, _datastore, { navigate, network, setDatastore, goBack, instrumentTrack }) => {
    const noOfOtpDigits = action?.payload?.noOfOtpDigits;
    if (`${action.payload.value}`.length > (noOfOtpDigits - 1)) {
        const response = await network.post(api.verifyEmail, {
            otp: action.payload.value,
            emailId: action.payload.emailId
        }, { headers: await getAppHeader(), handleFromMF: true }, async () => {
            await setDatastore(ROUTE.ENTER_EMAIL, "enterEmailScreen", {
                state: InputStateToken.DEFAULT,
                value: '0',
                counter: counter++
            });
        });
        if (response.status === 200) {
            const userContextResponse = await network.post(api.userContext, {}, {
                headers: await getAppHeader(),
            });
            await SharedPropsService.setUser(userContextResponse.data);
            await setDatastore(ROUTE.ENTER_EMAIL, "enterEmailScreen", {
                state: InputStateToken.SUCCESS,
                counter: counter++
            });
            const currentStepId = userContextResponse.data.linkedApplications[0].currentStepId;
            const applicationId = await getApplicationId();
            await goBack();
            const enabledRTAFlowResponse = await network.get(`${api.isFromMFCentralFlow}${applicationId}`, { headers: await getAppHeader() });
            if (enabledRTAFlowResponse?.status === 200) {
                const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === MfCentralFlow;
                if (isFromMFCentral && currentStepId === ROUTE.MF_PLEDGE_PORTFOLIO) {
                    await navigate(ROUTE.MFC_FETCH_ANCHOR);
                }
                else {
                    const route = await nextStepId(userContextResponse.data.linkedApplications[0].currentStepId, "", userContextResponse.data.linkedApplications[0]?.stepStatusMap);
                    navigate(route.routeId, route.params);
                }
            }
        }
        else {
            const errorMessage = response?.response?.data?.message;
            if (response?.response?.status === 400) {
                if (response?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
                    await setDatastore(ROUTE.ENTER_EMAIL, "enterEmailScreen", {
                        state: InputStateToken.DISABLED,
                        caption: { error: errorMessage },
                        otpLimitExceeded: true,
                        counter: counter++
                    });
                }
                else {
                    await setDatastore(ROUTE.ENTER_EMAIL, "enterEmailScreen", {
                        state: InputStateToken.ERROR,
                        caption: { error: errorMessage },
                        counter: counter++
                    });
                }
            }
            else {
                await setDatastore(ROUTE.ENTER_EMAIL, "enterEmailScreen", {
                    state: InputStateToken.ERROR,
                    caption: { error: errorMessage },
                    counter: counter++
                });
            }
        }
    }
};
export const textOnChange = async (action, _datastore, {}) => {
    emailId = action.payload.value;
};
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ || params?.plj) {
        navigate(ROUTE.BORROWER_LANDING_SCREEN);
    }
    else {
        // @ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
        window?.parent?.postMessage("Exit callback", "*");
        if (isFromAndroidWebview() && isFromTDLPlatform()) {
            window.open("closeActivity", "_parent");
        }
        else {
            await goBack();
        }
    }
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, 'enterEmailScreen', {
        isDisabled: !action?.payload?.value
    });
};
export const closeModalAction = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, 'enterEmailScreen', {
        showErrorModal: false,
        counter: counter++,
        errorMessage: '',
    });
};
